import { styled, keyframes } from '@web/theme';


const draw = keyframes`
  from {
      stroke-dashoffset: 3800;
  }
  to {
      stroke-dashoffset: 0;
  }
`;
const fadeStroke = keyframes`
  to {
      stroke-opacity: 1;
  }
`;
const fill = keyframes`
  from {
      fill-opacity: 0;
  }
  to {
      fill-opacity: 1;
  }
`;
export const StyledSvg = styled.svg<{ light?: boolean }>`
  filter: drop-shadow(0px 0px 2px ${({ theme }) => theme.page.txt});
  stroke: ${({ theme, light }) => !light ? theme.page.txt : theme.page.bg};
  stroke-width: 15px;
  fill: transparent;
  
  path {
    fill-opacity: 0;
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards;
    animation-name: ${draw}, ${fadeStroke}, ${fill};
    animation-duration: 5s, 1s, 1s;
    animation-delay: 0s, 2s, 2s;
  }
  
  &:hover {
    fill: ${({ theme, light }) => !light ? theme.page.txt : theme.page.bg};
  }
`;
export const StyledAnimatedLogo = styled.div`
	transition: width .5s, height .5s;
`;
